<section class="not-found">
  <h1>Seite nicht gefunden</h1>
  <p>Die gewünschte Seite konnte nicht gefunden werden.</p>
  <button mat-flat-button color="primary" routerLink="/vorauswahl">Zur Terminbuchung</button>
</section>
